import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";

@Component({
    selector: "app-not-found",
    templateUrl: "./not-found.component.html",
    styleUrls: ["./not-found.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundComponent implements OnInit {
  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  ngOnInit() {}
}
